interface EnumItemData {
  name?: string;
  value?: unknown;
  [key: string]: unknown;
}

class EnumItem {
  name!: string;
  value!: unknown;
  [key: string]: unknown;

  constructor(object: EnumItemData) {
    for (const key of Object.keys(object)) {
      this[key] = object[key];
    }
  }

  inspect() {
    return `Enum(${this.name}: ${this.value})`;
  }
}

class Enum {
  object: Record<string, unknown>;
  [key: string]: unknown;

  constructor(object: Record<string, unknown>) {
    this.object = object;

    for (const key of Object.keys(object)) {
      const value = object[key];

      let itemData: EnumItemData;
      if (typeof value === 'object' && value !== null) {
        itemData = value as EnumItemData;
        itemData.name = key;
      } else {
        itemData = { name: key, value: value };
      }

      this[key] = new EnumItem(itemData);
    }
  }

  fromValue(value: unknown): EnumItem {
    for (const key of Object.keys(this.object)) {
      if ((this[key] as EnumItem).value === value) {
        return this[key] as EnumItem;
      }
    }

    throw new Error(`No enum for value: ${value}`);
  }
}

export { Enum, EnumItem };
